/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import styles from "./ToggleButton.module.css";

const ToggleButton = ({
  id,
  label,
  color,
  children,
  isSelected,
  type,
  skinSelected,
  ...delegated
}) => {
  if (type === "skinSelector") {
    return (
      <button
        {...delegated}
        aria-pressed={isSelected === id ? true : false}
        className={styles.skinSelector}
        style={{ backgroundColor: color }}
        onClick={() => {
          skinSelected(id);
        }}
      />
    );
  } else {
    return (
      <button
        {...delegated}
        aria-pressed={isSelected}
        className={styles.toggleButton}
        style={{ backgroundColor: color }}
      >
        <span className="visually-hidden">{label}</span>
        {children}
      </button>
    );
  }
};

export default ToggleButton;
